import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Dev sandbox router.
 *
 * Auth-free design surfaces mounted under `/dev/`. These bypass the providers
 * and auth gate in `index.tsx` entirely — they render static, mock-data copies
 * of components so they can be designed in isolation. Add a surface by giving it
 * a path here.
 */
import React from "react";
import { CardLab } from "./card-lab";
import "./dev-app.scss";
/** True for any path the dev sandbox owns. */
export function isDevPath(pathname) {
    return pathname === "/dev" || pathname.startsWith("/dev/");
}
const ROUTES = [{ path: "/dev/card", label: "Card", render: () => _jsx(CardLab, {}) }];
/** A bare index of the available dev surfaces. */
const DevIndex = () => (_jsxs("div", { className: "dev-index", children: [_jsx("h1", { className: "dev-index__title", children: "Dev sandbox" }), _jsx("ul", { className: "dev-index__list", children: ROUTES.map((r) => (_jsxs("li", { children: [_jsx("a", { href: r.path, children: r.label }), _jsx("span", { className: "dev-index__path", children: r.path })] }, r.path))) })] }));
export const DevApp = () => {
    const path = window.location.pathname.replace(/\/+$/, "");
    const match = ROUTES.find((r) => r.path === path);
    return _jsx(_Fragment, { children: match ? match.render() : _jsx(DevIndex, {}) });
};
